import React,{useState,useEffect}  from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './member_dashboard.css';

export const Member_Dashboard=(props)=>{
    useEffect(()=>{
      
        //alert(JSON.stringify(props.dashboardData));
      
    },[props.dashboardData]);
    return(<>{1>0?
    <div class="row">
        {/* Available Balance */}
        <div class="col-12 col-md-12 mt-10 mb-10 ">
              <div class="progress-group">
              <a className='btn-sm btn-primary'  href={"javascript:void(0)"}
       data-bs-toggle="modal"  data-bs-target="#divPurchaseBalance" ><i class="fa fa-credit-card mr-2" aria-hidden="true">Purchase Balance</i></a>

               <span class="float-right">
                <b>Available Balance </b><br/><span class="float-right  badge bg-primary">{props.dashboardData?.avail_balance}</span>
                </span>
                    </div>
            </div>
            {/* End of Available Balance */}

              <div class="col-12 col-sm-12 col-md-3">
                <Link to={'/view_all_request'}> 
                <div class="info-box">
                  <span class="info-box-icon bg-info elevation-1">
                    {/* <i class="fas fa-cog white"></i> */}
                    <i class="fa fa-save white"></i>
                    </span>
    
                  <div class="info-box-content">
                    <span class="info-box-text">Pending Request</span>
                    <span class="info-box-number">
                     
                      <small>{props.dashboardData?.member_reqests?.pending}</small>
                    </span>
                  </div>
                  
                </div>
                </Link>
              </div>
              
              <div class="col-12 col-sm-12 col-md-3">
              <Link to={'/view_all_request'}>
                <div class="info-box mb-3">
                  <span class="info-box-icon bg-danger elevation-1">
                    <i class="fa fa-thumbs-up white"></i>
                    </span>
    
                  <div class="info-box-content">
                    <span class="info-box-text">Under Process</span>
                    <span class="info-box-number">
                    <small>{props.dashboardData?.member_reqests?.under_process}</small>
                    </span>
                  </div>
                  
                </div>
               </Link>
              </div>

              <div class="col-12 col-sm-12 col-md-3">
           <Link to={"/view_all_request"}>
            <div class="info-box mb-3">
              <span class="info-box-icon bg-warning"><i class="fa fa-tag white"></i></span>

              <div class="info-box-content">
                <span class="info-box-text">Rejected/Canceled</span>
                <span class="info-box-number">
                <small>{props.dashboardData?.member_reqests?.rejected_cancelled}</small>
                </span>
              </div>
              
            </div>
            </Link>
            </div>

           

            {/* Intro Video */}
            <div class="col-12 col-sm-12 col-md-3">
              <Link to={"/view_all_request"}>
            <div class="info-box mb-3">
              <span class="info-box-icon bg-danger"><i class="fa fa-search white"></i></span>

              <div class="info-box-content">
                <span class="info-box-text">{"View All"}</span>
                <span class="info-box-number">{props.dashboardData?.member_reqests?.all}</span>
              </div>
              
            </div>
            </Link>
            </div>

           
             
              {/* <div class="clearfix hidden-md-up"></div> */}
              {/* goal completion */}
                    
              
            </div>:''}</>);

}
export default Member_Dashboard;